import { render, staticRenderFns } from "./alertsConfirm.vue?vue&type=template&id=0e5b57e9"
import script from "./alertsConfirm.vue?vue&type=script&lang=js"
export * from "./alertsConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports